import { IconKey,IconReportMoney } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconReportMoney
};
//

const Finance_Account = {

    id: 'Finance_Account',
    title: 'Finance and Account',
    type: 'group',
    display_id:'L',
    icon: icons.IconReportMoney,
    children: [
        {
            id: 'Finance_Account_ratna',
            title: 'Ratna',
            type: 'item',
            display_id:46,
            url: '/Department/finance/ratna',
            breadcrumbs: false
        },
        {
            id: 'Finance_Account_HARDWARE',
            title: 'Hardware',
            type: 'item',
            display_id:58,
            url: '/Department/finance/hardware',
            breadcrumbs: false
        },
    ]
}

export default Finance_Account;